import {dialog} from '@cypro/ui/components'
import {AbortCleanroomDialog, AbortCleanroomDialogProps} from './abort-cleanroom-dialog'

const ABORT_CLEANROOM_DIALOG_ID = 'abort-cleanroom-dialog'

export function openAbortCleanroomDialog(props: AbortCleanroomDialogProps) {
  try {
    dialog.remove(ABORT_CLEANROOM_DIALOG_ID)
  } catch {}

  return dialog.open(ABORT_CLEANROOM_DIALOG_ID, {
    id: ABORT_CLEANROOM_DIALOG_ID,
    children: <AbortCleanroomDialog {...props} />,
    size: 'lg',
  })
}

export function closeAbortCleanroomDialog() {
  dialog.close(ABORT_CLEANROOM_DIALOG_ID)
}
